import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import ThemeContext from "./context/ThemeContext";
import { AuthContextProvider } from "./context/auth-context";
import {
  installGlobalDateDisplayFormatter,
  installJsPdfDateFormatting,
  installSpreadsheetDateFormatting,
} from "./utils/dateFormat";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { SystemAlertHost } from "./components/SystemAlert";

const appRoot = document.getElementById("root");

installSpreadsheetDateFormatting(XLSX);
installJsPdfDateFormatting(jsPDF);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename="">
        <SystemAlertHost />
        <AuthContextProvider>
          <ThemeContext>
            <App />
          </ThemeContext>
        </AuthContextProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  appRoot
);

installGlobalDateDisplayFormatter(appRoot);

reportWebVitals();
